import { render } from "./ValidationErrorModal.vue?vue&type=template&id=1016e21d&scoped=true"
import script from "./ValidationErrorModal.vue?vue&type=script&lang=js"
export * from "./ValidationErrorModal.vue?vue&type=script&lang=js"

import "./ValidationErrorModal.vue?vue&type=style&index=0&id=1016e21d&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1016e21d"]])

export default __exports__